import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'

export class InsuranceApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'Fiba/IsInsurance',
      requesterInfo,
    })
  }

  public async getInsurance(): Promise<boolean> {
    return await this.getAsync<boolean>()
  }
}
